<template>
  <div class="air-monitor-base-container">
    <MCard :title="$t('人员管理')" title-align="center">
      <MForm v-bind="formConfig" :model="formModel" />

      <MTable
        i18n-path="query"
        :loading="loading"
        :tableData="hisData"
        :tableColumn="tableColumn"
        :pagiOption="pagiOption"
        height="calc(100% - 80px)"
        v-on:search="search"
      ></MTable>
    </MCard>
  </div>
</template>

<script>
import MTable from '@/components/mTable/m-table';
import MForm from '@/components/form/index.vue';
import MCard from '@/components/mCard/index.vue';

import { merge } from 'lodash';

import { arrify } from '@/utils/arrify';
import { personListServer } from '@/api/air-monitor/emergency-center';

export default {
  name: 'historyWarn',
  components: { MTable, MForm, MCard },
  props: {
    sn: String,
    deviceType: String
  },
  computed: {
    comParams() {
      const { formModel, pagiOption } = this;
      return merge(
        {
          limit: pagiOption.limit,
          offset: pagiOption.offset
        },
        formModel
      );
    }
  },
  data() {
    return {
      hisData: [],
      loading: true,
      formModel: {
        name: ''
      },

      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30, 100, 200],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableColumn: [
        { label: '应急人员', prop: 'name' },
        { label: '电话', prop: 'phone' },
        { label: '备注', prop: 'remarks' }
      ],
      formConfig: {
        i18nPath: 'query',
        config: {
          labelWidth: 'auto',
          span: 24,
          labelSuffix: ':',
          options: [
            {
              type: 'input',
              prop: 'name',
              span: 4,
              label: '人员名称'
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '查询',
                loading: false,
                type: 'primary',
                handler: async ({ setLoading }) => {
                  setLoading(true);
                  await this.search();
                  setLoading(false);
                }
              }
            ]
          }
        },
        model: {
          name: ''
        },
        dataSource: {},
        rules: {}
      }
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    langChangeHandler() {
      this.search();
    },
    search() {
      this.loading = true;

      personListServer(this.comParams)
        .then(res => {
          this.hisData = res.data.list;
          this.pagiOption.total = res.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    disposalAlarm(data) {
      const multiAlarmRef = this.$refs.multiAlarmRef;

      multiAlarmRef.api = obj => {
        console.log(obj);
      };

      multiAlarmRef.show();
      multiAlarmRef.setFormData(data);
      multiAlarmRef.setTableData(arrify(data));
    },
    resetSearch() {
      const newData = this.$options.data.call(this);
      this.hisData.splice(0);
      Object.assign(this.formModel, newData.formModel);
      Object.assign(this.pagiOption, newData.pagiOption);
    }
  },
  watch: {
    flag() {
      this.formModel.name = '';
    }
  }
};
</script>

<style lang="scss"></style>
